import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MatListModule } from '@angular/material/list';

import { SidebarButton, SidebarButtonComponent } from '../sidebar-button/sidebar-button.component';

@Component({
  selector: 'app-sidebar-button-group',
  standalone: true,
  imports: [CommonModule, MatListModule, SidebarButtonComponent],
  templateUrl: './sidebar-button-group.component.html',
  styleUrls: ['./sidebar-button-group.component.scss'],
})
export class SidebarButtonGroupComponent {
  @Input() buttons: SidebarButton[] = [];
  @Input() isExpanded: boolean = false;
  @Output() buttonClick = new EventEmitter<SidebarButton>();

  onButtonClick(button: SidebarButton): void {
    this.buttonClick.emit(button);
  }
}
